import { DROP__zone } from './DROP__zone';

class SERVICE__drop {
  zones = new Map<string, DROP__zone>();

  register(zone: DROP__zone) {
    this.zones.set(zone.id, zone);
    return () => void this.zones.delete(zone.id);
  }

  resolve_drop(x: number, y: number) {
    let zone_target = null;

    for (const zone of this.zones.values()) {
      const rect = zone.get_rect();
      if (!rect) continue;

      if (x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom) {
        zone_target = zone;
        break;
      }
    }

    if (zone_target != null) zone_target.on_drop();
  }
}

export const service_drop = new SERVICE__drop();
